import Storage from "../../common/functions/storage.es6";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export class Intro {
    constructor() {
        this.storage = new Storage();
        this.init();
    }

    init() {
        this.introSkip();
        this.introEnd();
    }

    introIn() {
        document.body.classList.add("-introin");
        this.storage.data.intro && this.storage.set("intro", false);

        setTimeout(() => {
            document.body.classList.remove("-lock");
        }, 4000);
    }

    introSkip() {
        document.body.classList.add("-lock");

        const url = new URL(location);
        const params = url.searchParams;

        if (params.get("skip") === "false" || this.storage.data.intro) {
            this.introIn();
        } else if (params.get("skip") === "true" || !this.storage.data.intro) {
            document.body.classList.add("-introskip");
            document.body.classList.remove("-lock");
        }

        ScrollTrigger.refresh();
    }

    introEnd() {
        const mql = window.matchMedia("(max-width: 834px)");
        const device = mql.matches ? "sp" : "pc";
        const last = document.querySelector(`[data-intro-anime-last="${device}"]`);
        //console.log(last);
        last.addEventListener("animationend", () => {
            document.body.classList.add("-introend");
        });
    }
}
